import {Component, Input, OnInit, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {DynamicFormService} from "../../../../routes/dev-tools/dynamic-form/dynamic-form.service";
import {ScoringValueService} from "../../../../routes/jy-srm/marking-scheme/marking-scheme/scoring-value.service";
import { CommonsService } from "@core/service/commons.service";
import {NgForm} from "@angular/forms";

@Component({
  selector: 'app-scoring-component',
  templateUrl: './scoring-component.component.html',
  styles: []
})
export class ScoringComponentComponent implements OnInit,OnChanges {

  constructor(private dynamicFormService: DynamicFormService, private scoringValueService: ScoringValueService,private commonsService:CommonsService) {
  };
  @ViewChild('scoreingForm') scoreingForm:NgForm;
  @Input() planObj;
  @Input() scoreObj;
  @Input() personIsScore;
  @Input() readOnly;
  @Output() private childOuter = new EventEmitter();
  public scoreFields:any = {};

  submitScoring() {
    for (const i in this.scoreingForm.controls) {
      this.scoreingForm.controls[i].markAsDirty();
      this.scoreingForm.controls[i].updateValueAndValidity();
    }
    if(!this.scoreingForm.valid){
      return;
    }
    let submitScoreObj = JSON.parse(JSON.stringify(this.scoreObj));
    submitScoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName] = this.scoreFields;
    this.scoringValueService.update(submitScoreObj).subscribe(() => {
     this.commonsService.showSuccessMessage('commons.info.commitSucceed');
     this.childOuter.emit(this.scoreFields);
    });
  }

  getAllScore(field){
    if(this.scoreFields[field.fieldName] && this.scoreFields[field.fieldName] > this.getConfigAttr(field.config,'maxScore')){
      this.commonsService.showWarningMessage(this.commonsService.translate('supplier-item-score.source-scoring.notThan') + this.getConfigAttr(field.config,'maxScore') + this.commonsService.translate('supplier-item-score.source-scoring.againScore'));
      this.scoreFields[field.fieldName] = null;
    }
    if(this.scoreFields[field.fieldName] && this.scoreFields[field.fieldName] < this.getConfigAttr(field.config,'minScore')){
      this.commonsService.showWarningMessage(this.commonsService.translate('supplier-item-score.source-scoring.moreThan')+ this.getConfigAttr(field.config,'minScore') + this.commonsService.translate('supplier-item-score.source-scoring.againScore'));
      this.scoreFields[field.fieldName] = null;
    }
    this.scoreFields.total_score = 0;
    if(this.planObj.dynamicForm.dynamicTables[0]){
      for(let i=0;i<this.planObj.dynamicForm.dynamicTables[0].dynamicFields.length;i++){
        if(this.scoreFields[this.planObj.dynamicForm.dynamicTables[0].dynamicFields[i].fieldName]){
          this.scoreFields.total_score += Number(this.scoreFields[this.planObj.dynamicForm.dynamicTables[0].dynamicFields[i].fieldName]);
        }
      }
      if(JSON.parse(this.planObj.dynamicForm.config).passScore && this.scoreFields.total_score < JSON.parse(this.planObj.dynamicForm.config).passScore){
        this.scoreFields.result = false;
      }else{
        this.scoreFields.result = true;
      }
    }
  }

  ngOnChanges(changes:SimpleChanges){
    if(changes.scoreObj && this.scoreObj){
      if(this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName]){
        if(this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName].length == 1){
          this.scoreFields = JSON.parse(JSON.stringify(this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName][0]));
        }else{
          this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName].forEach((data) =>{
            if(data.person == this.scoreObj.data.personId){
              this.scoreFields = JSON.parse(JSON.stringify(data));
            }
          })
        }
      }
      if(this.personIsScore){
        this.readOnly = true;
      }
      this.planObj.dynamicForm.dynamicTables[0].dynamicFields.forEach((data) =>{
        if (data.config && JSON.parse(data.config).rules) {
          data.rules = JSON.parse(data.config).rules;
        }
      });
      this.expand();
    }
  }
  ngOnInit() {
  }

  //获取config中的字段
  getConfigAttr(config, attr) {
    return JSON.parse(config)[attr];
  }

  //评分细则
  public gradRulesVisible: any = false;

  gradRulesOk() {
    this.gradRulesVisible = false;
  }

  public gradRuleList: any;

  showRuleList(item) {
    this.gradRulesVisible = true;
    if (JSON.parse(item.config).rules) {
      this.gradRuleList = JSON.parse(item.config).rules;
    }
  }

  public allExpand:boolean = false;
//  表格全部展开
  expand(){
    this.planObj.dynamicForm.dynamicTables[0].dynamicFieldGroups.forEach((item) => {
      item.expands = true;
    });
    this.allExpand = true;
  }

//  表格全部收起
  packUp(){
    this.planObj.dynamicForm.dynamicTables[0].dynamicFieldGroups.forEach((item) => {
      item.expands = false;
    });
    this.allExpand = false;
  }
}
